import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const getPromptQuestions = async () => {
  const config = {
    method: "get",
    url: `${ADMIN_PORTAL_API_BASE_URL}/get_prompt_questions`,
    headers: {
      Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN,
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};